/**
 * defa.views.InvoiceSnippet
 * A snippet view for a single invoice.
 * @version 1.2.1
 */
import Snippet from 'scripts/poppet/snippet';

const InvoiceSnippet = Snippet.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	className: function () {
		return this.getClassName();
	},
	
	templateContext: function () {
		
		let superContext = Snippet.prototype.templateContext.call( this );
		
		return _.extend( superContext, {
			iconClass: 'icon icon-labelled icon-material icon-invoice',
			header   : this.model.getDate(),
			textRT   : this.model.get( 'invoiceNumber' ),
			//termStatus : this.getStatus(),
		} );
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Sets the invoice class based on the invoice status.
	 * @return {string}  A space-separated string of html-classes.
	 */
	getClassName: function () {
		
		let classes = 'snippet';
		
		if ( 'OPEN' === this.model.get( 'status' ) ) {
			classes += ' invoice-open';
		}
		
		if ( 'PENDING' === this.model.get( 'status' ) ) {
			classes += ' invoice-pending';
		}
		
		if ( this.model.get( 'counterInvoice' ) ) {
			classes += ' invoice-counter';
		}
		
		return classes;
		
	},
	
	/**
	 * Gets text to be placed in the right top corner.
	 * @return {string}  The string to be written in the corner.
	 */
	// getTextRT: function() {
	// return 
	// },
	
	
} );

export default InvoiceSnippet;